export default "__VITE_ASSET__Ayv3f5hI__"